export default __webpack_public_path__ + "static/media/goshen9.08116ae8.jpg";